import { useSearchParams } from "react-router-dom";
import { useState } from "react";

// Asset surfaces (posts, faqs, hooks, story ideas, …) all share an
// in-page `program` filter. When deep-linked from a playbook (e.g.
// `/affiliates/dashboard/assets/posts?program=weight-management`) we
// want the filter to seed from the URL on mount so the affiliate
// lands on the right slice immediately.
//
// Returns `[program, setProgram]` where `setProgram` also writes the
// value back into the URL so refresh/share preserves the filter.
//
// Defaults to "all" when no query param is present.
export default function useProgramFromQuery() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initial = searchParams.get("program") || "all";
  const [program, setProgramState] = useState(initial);

  const setProgram = (next) => {
    setProgramState(next);
    // Mirror to URL so refresh/share keeps the filter, but skip the
    // history entry — the affiliate is filtering, not navigating.
    setSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev);
        if (next === "all" || !next) {
          params.delete("program");
        } else {
          params.set("program", next);
        }
        return params;
      },
      { replace: true },
    );
  };

  return [program, setProgram];
}
